import { Modal } from "react-bootstrap";
import styled from "styled-components";
export const ModalStyles = styled(Modal)`
  .modal-body .modal-main-img {
    border-radius: 7px;
    overflow: hidden;
    aspect-ratio: 193 / 110;
    width: 100%;
    height: auto;
    margin-top: 10px;
  }
  .modal-body .modal-main-img img {
   object-fit: cover;
  }
  @media (max-width: 768px) {
    .modal-body {
      width: 350px;
    }
  }
  @media (max-width: 350px) {
    .modal-body {
      width: 260px;
    }
  }
`;
